import routes from '@/routes'

import render from './render'

function normalizeOrder(meta) {
  if (meta && typeof meta.navOrder === 'number') {
    return meta.navOrder
  }

  return Number.POSITIVE_INFINITY
}

function sortChildren(children) {
  return children
    .map((child, index) => {
      return {
        child,
        index
      }
    })
    .sort((firstItem, secondItem) => {
      const firstOrder = normalizeOrder(firstItem.child.meta)
      const secondOrder = normalizeOrder(secondItem.child.meta)

      if (firstOrder !== secondOrder) {
        return firstOrder - secondOrder
      }

      return firstItem.index - secondItem.index
    })
    .map(({ child }) => {
      return child
    })
}

function filterChildren(children) {
  const filteredChildren = children.filter(({ meta }) => {
    if (!meta) {
      return false
    } else {
      let hasPermit = true
      if (meta.permission) {
        hasPermit = this.checkPermissions(meta.permission, meta.permissionAccept)
      }
      if (meta && meta.nav && hasPermit) {
        return true
      }
    }
  })

  return sortChildren(filteredChildren)
}

export default {
  name: 'NavigationList',

  computed: {
    routes() {
      return routes.reduce((result, { name, meta, children }) => {
        if (meta) {
          let hasPermit = true
          if (meta.permission) {
            hasPermit = this.checkPermissions(meta.permission, meta.permissionAccept)
          }
          if (meta.nav && hasPermit) {
            let navChildren = []
            if (children) {
              navChildren = filterChildren.call(this, children)
            }
            result.push({
              name,
              meta,
              children: navChildren
            })
          }
        }

        if (name === 'admin') {
          if (children) {
            for (const child of children) {
              if (child.meta) {
                let hasPermitChild = true
                if (child.meta.permission) {
                  hasPermitChild = this.checkPermissions(child.meta.permission, child.meta.permissionAccept)
                }
                if (child.meta.nav && hasPermitChild) {
                  let childNavChildren = []
                  if (child.children) {
                    childNavChildren = filterChildren.call(this, child.children)
                  }
                  result.push({
                    name: child.name,
                    meta: child.meta,
                    children: childNavChildren
                  })
                }
              }
            }
          }
        }

        return result
      }, [])
    }
  },

  render
}
